import { InjectionToken } from '@angular/core';

import { NavigationDataAdapter } from './navigation-data-adapter.interface';

export const NAVIGATION_DATA_ADAPTER = new InjectionToken<NavigationDataAdapter>('Navigation Data Adapter');
